import { render, staticRenderFns } from "./AddIzinTamu.vue?vue&type=template&id=86001eee&lang=pug&"
import script from "./AddIzinTamu.vue?vue&type=script&lang=js&"
export * from "./AddIzinTamu.vue?vue&type=script&lang=js&"
import style0 from "./AddIzinTamu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports